import { VERSION } from '@app/shared/consts/version';
import { VERSION_SHA } from '@app/shared/consts/version-sha';

/** @example 2023.5.21-55c6be7 */
export function getVersion(): string {
  return `${VERSION}-${VERSION_SHA}`;
}
